define(
    "diy/undo-redo/FeatureSet",
    [
    ],
    /**
     * @returns {module.undoRedo.FeatureSet}
     */
    function () {
        'use strict';
        var FeatureSet;
        /**
         * @class module.undoRedo.FeatureSet
         * @template module.undoRedo.FeatureSet
         * @lends {module.undoRedo.FeatureSet.prototype}
         * @constructor
         */
        FeatureSet = Klazz.extend({
            /** @type {Object} */
            features: {},

            initialize: function(){
                this.features = {};
            },

            /**
             *
             * @param {jimdoData.features} features
             * @param {module.undoRedo.Settings} settings
             */
            load: function (features, settings) {

                settings.getFeatures().forEach(function (feature){
                    var featureEnabled, featureValue ;

                    if (typeof features[feature.key] !== 'undefined') {
                        featureEnabled = (features[feature.key].toString().length && parseInt(features[feature.key], 10) !== 0);
                        featureValue = features[feature.key];
                    } else {
                        featureEnabled = feature.defaultEnabled;
                        featureValue = feature.defaultValue;
                    }
                    this.features[feature.name] = {
                        enabled: featureEnabled,
                        value: featureValue
                    };
                }.bind(this));
            },

            /**
             *
             * @param {String} feature
             * @returns {Boolean}
             */
            isEnabled: function(feature) {
                return (typeof this.features[feature] !== 'undefined' && this.features[feature].enabled === true);
            },

            /**
             *
             * @param {String} feature
             * @returns {*}
             */
            getValue: function(feature) {
                if (typeof this.features[feature] !== 'undefined') {
                    return this.features[feature].value;
                }
                return undefined;
            }

        });
        return FeatureSet;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/FeatureSet.js
 ** module id = 890
 ** module chunks = 0
 **/